import { atom } from 'jotai';
import { ExpiryType, OrderHistoryItemLogEntryType, OrderType, PeriodType, TradeType } from '../../types';

export enum LogType {
  Create = 'Create',
  Edit = 'Edit',
  Cancel = 'Cancel',
  Fulfillment = 'Fulfillment',
  Rejection = 'Rejection',
}

export enum Period {
  Daily = 'Daily',
  Last7Days = 'Last7Days',
  Last14Days = 'Last14Days',
  Last30Days = 'Last30Days',
}

export type OrderLogDetails = {
  instrumentName: string;
  tradeType: TradeType;
  orderType: OrderType;
  price: number;
  ccy: string;
  quantity: number;
  expiryType?: ExpiryType;
  expiry?: Date;
  stopActivationPrice?: number;
  rejectReason?: string;
  orderValue?: number;
  commission?: number;
  tradingPhase?: string;
  instrumentCategory?: string;
};

export type OrderLog = {
  logEntryType: OrderHistoryItemLogEntryType;
  tradeType: TradeType;
  ticker: string;
  orderId: string;
  accountNumber: string;
  transactionDate: Date;
  details: OrderLogDetails;
};

export type OrderLogs = {
  orderLogs: Array<OrderLog>;
  isLoading: boolean;
  error: boolean;
  periodType: PeriodType;
};

export const orderLogsAtom = atom<OrderLogs>({
  orderLogs: [],
  isLoading: false,
  error: false,
  periodType: PeriodType.Last7days,
});
